import React from 'react';
import { Toast } from './Toast';
import type { Toast as ToastItem } from '../types/resource.types';

interface ToastContainerProps {
    toasts: ToastItem[];
    onRemoveToast: (id: string) => void;
}

export const ToastContainer = ({
    toasts,
    onRemoveToast,
}: ToastContainerProps) => {
    if (!toasts.length) return null;

    return (
        <div className="toast-stack">
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    onClose={() => onRemoveToast(toast.id)}
                />
            ))}
        </div>
    );
};